import { Box, Button, Text, VStack, Icon, Flex } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FiLock } from "react-icons/fi";
import { IconType } from "react-icons/lib";

interface BlurOverlayProps {
  children: ReactNode;
  isBlurred: boolean;
  modalTitle?: string;
  modalMessage?: string;
  modalIcon?: IconType;
  ctaText?: string;
  onCtaClick?: () => void;
  ctaVariant?: "primary" | "secondary";
  icon?: ReactNode;
  image?: any;
}

const BlurOverlay = ({
  image,
  children,
  isBlurred,
  modalTitle = "Upgrade Required",
  modalMessage = "This feature requires a premium plan. Please upgrade to continue.",
  modalIcon = FiLock,
  ctaText = "Upgrade Now",
  onCtaClick,
  ctaVariant = "primary",
  icon,
}: BlurOverlayProps) => {
  return (
    <Box position="relative" w="100%" h="100%">
      {isBlurred ? (
        <Box
          backgroundSize="cover"
          backgroundPosition="top"
          backgroundRepeat="no-repeat"
          backgroundImage={image ? `url(${image})` : "none"}
          w="100%"
          h="100%"
        ></Box>
      ) : (
        <Box
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          w="100%"
          h="100%"
        >
          {children}
        </Box>
      )}

      {isBlurred && (
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={10}
        >
          <Box
            bg="white"
            borderRadius="16px"
            maxW="400px"
            mx={4}
            boxShadow="0px 20px 40px rgba(0, 0, 0, 0.15)"
            p={6}
          >
            <VStack spacing={2} textAlign="center">
              {icon || (
                <Box
                  borderRadius="full"
                  p={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={modalIcon} boxSize={6} color="blue.400" />
                </Box>
              )}
              <Text fontSize="xl" fontWeight="600" color="gray.800">
                {modalTitle}
              </Text>
              <Text color="gray.600" fontSize="sm" lineHeight="1.5">
                {modalMessage}
              </Text>
              {onCtaClick ? (
                <Button
                  onClick={onCtaClick}
                  w="full"
                  mt={2}
                  bg={ctaVariant === "primary" ? "#000000" : "transparent"}
                  color={ctaVariant === "primary" ? "#FFFFFF" : "#000000"}
                  border={
                    ctaVariant === "secondary" ? "2px solid #000000" : "none"
                  }
                  rounded="md"
                  fontWeight="600"
                  fontSize="16px"
                  px={6}
                  py={3}
                  _hover={{
                    bg: ctaVariant === "primary" ? "#333333" : "#F5F5F5",
                  }}
                  _active={{
                    bg: ctaVariant === "primary" ? "#000000" : "#E5E5E5",
                  }}
                >
                  {ctaText}
                </Button>
              ) : null}
            </VStack>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default BlurOverlay;
